<template>
  <div class="tab-pane fade in active">
    <div class="drive">
      <div class="lists">
        <div class="list-content">
          <div
            class="itemlist messagelist"
            v-for="(request, index) in requests"
            :key="request.requestor_created_date"
          >
            <div class="item-groupmessage-info">
              <a>
                <p>
                  <span :title="request.requestor_message"
                    >{{ request.requestor_created_date }}
                    {{ request.requestor_name }}申请加入群组【{{
                      request.group_name
                    }}】 入群原因：{{ request.requestor_message }}</span
                  >
                </p>
              </a>
            </div>
            <div class="item-groupmessage-menu" v-if="right__group_requests">
              <a
                @click="handleRequest('adopt', request, index)"
                class="btn btn-default btn-xs"
              >
                <i class="ti-check"></i>
                同意
              </a>
              <a
                @click="handleRequest('ignore', request, index)"
                class="btn btn-default btn-xs"
              >
                <i class="ti-close"></i>
                忽略
              </a>
              <a
                @click="handleRequestModal(request)"
                class="btn btn-default btn-xs"
              >
                <i class="ti-close"></i>
                拒绝
              </a>
            </div>
          </div>
          <div class="loadingbox" v-show="msgLoading">
            <section class="loading Animation1">
              <section class="shape shape-1"></section>
              <section class="shape shape-2"></section>
              <section class="shape shape-3"></section>
              <section class="shape shape-4"></section>
            </section>
            <h4>正在加载，请稍后……</h4>
          </div>
          <div class="nofile" v-if="msgNothing">
            <div class="pic">
              <img src="@/assets/images/notopic.svg" />
            </div>
            <h4>暂时没有消息</h4>
          </div>
        </div>
      </div>
      <div
        aria-labelledby="myModalLabel"
        class="modal fade"
        id="message_reason"
        role="dialog"
        tabindex="-1"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                aria-label="Close"
                class="close"
                data-dismiss="modal"
                type="button"
              >
                <i class="iconfont icon-close"></i>
              </button>
              <h4 class="modal-title" id="myModalLabel">拒绝原因</h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <textarea
                  class="form-control"
                  placeholder="拒绝原因"
                  style="resize: vertical"
                  rows="4"
                  v-model="reason"
                  name="reason"
                  data-vv-as="拒绝原因 "
                  v-validate="{ required: true, min: 1, max: 250 }"
                ></textarea>
                <span class="help-block" v-show="errors.has('reason')">{{
                  errors.first("reason")
                }}</span>
              </div>
            </div>
            <div class="modal-footer">
              <button
                class="btn btn-default"
                data-dismiss="modal"
                type="button"
              >
                取消
              </button>
              <button class="btn btn-primary" type="button" @click="refuse()">
                确定
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { groupRequests, handleRequest } from "@/api/group/group";
export default {
  name: "GroupMsg",
  data() {
    return {
      refuseRequest: null,
      reason: "",
      msgLoading: false,
      msgNothing: false,
      requests: [],
    };
  },
  created() {
    this.groupRequests();
  },
  computed: {
    right__group_requests () {
      return this.$store.getters.right__group_requests
    },
    requestNums() {
      return this.$store.state.grouplist.requestNums;
    },
  },
  methods: {
    handleRequestModal(request) {
      this.refuseRequest = request;
      $("#message_reason").modal("show");
    },
    // 获取消息列表
    groupRequests() {
      this.msgNothing = false;
      this.msgLoading = true;
      groupRequests({
        type: "wait",
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.msgLoading = false;
            this.requests = res.entity;
            this.$store.commit("setRequestNums", res.entity.length);
            if (!res.entity.length) {
              this.msgNothing = true;
            }
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 处理申请
    handleRequest(type, request, index) {
      handleRequest({
        action: type,
        group_number: request.group_number,
        users_list: [request.requestor_user_number],
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.$store.commit("setRequestNums", this.requestNums - 1);
            if (this.requestNums < 1) {
              this.msgNothing = true;
            }
            this.requests.splice(index, 1);
            this.$message({
              type: "success",
              message: res.message,
            });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    // 拒绝申请
    refuse() {
      this.$validator.validate("reason").then((valid) => {
        if (valid) {
          let index = this.requests.indexOf(this.refuseRequest);
          handleRequest({
            action: "refuse",
            group_number: this.refuseRequest.group_number,
            users_list: [this.refuseRequest.requestor_user_number],
            reason: this.reason,
          })
            .then((res) => {
              if (res.status_code === 200) {
                $("#message_reason").modal("hide");
                this.$store.commit("setRequestNums", this.requestNums - 1);
                if (this.requestNums < 1) {
                  this.msgNothing = true;
                }
                this.requests.splice(index, 1);
                this.$message({
                  type: "success",
                  message: res.message,
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        }
      });
    },
  },
};
</script>

<style scoped>
</style>